/**
 * Minimal i18next initialisation for the admin app.
 *
 * The admin components use useTranslation() hooks.  We initialise i18next
 * with an empty bundle so the hooks don't throw; components will display
 * their raw translation keys (acceptable for an internal admin console).
 *
 * If you later want full translations, replace the resources object with the
 * locale bundles from @web/i18n/locales/*.json and add them here directly
 * (avoid importing @web/i18n/config because that file's deps resolve from
 * the web tree, not the admin tree, causing Rollup resolution failures).
 */
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: { en: { translation: {} } },
    fallbackLng: 'en',
    interpolation: { escapeValue: false },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupLocalStorage: 'eurion-language',
    },
  });

export default i18n;
